module.exports = __webpack_public_path__ + "img/c13.597db718.png";